import '../lib/typedef';
import { buildQuery } from '../lib/helper';
import client from '../lib/http-client-connection';

const endpoint = '/product';
const funnelUrl = process.env.VUE_APP_FUNNEL_URL || 'https://funnel.orderonline.id';

export default {
	getDropshipProducts(params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		const query = buildQuery(params);
		const url = `${endpoint}/dropship?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getAddedDropshipProducts(params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		// const query = buildQuery(params);
		const url = `${endpoint}/dropship/added`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	addDropshipProduct(id, params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		// const query = buildQuery(params);
		const url = `${endpoint}/${id}/dropship`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	duplicateFunnel(params, cb, errorCb) {
		const url = `${funnelUrl}/funnels/duplicate`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateProductFunnel(params, cb, errorCb) {
		const url = `${funnelUrl}/funnels/update_content_product`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getStatisticCategories(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `statistic/category?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},
	// remove Connection
	removeConnection(token, cb, errorCb) {
		const url = `user/connection/token/${token}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
